<mat-toolbar class="h-18! flex items-center justify-between">
  <!-- Esquerda: hamburger + brand mobile -->
  <div class="flex items-center gap-pmdf-3">
    <button mat-icon-button
            (click)="layout.toggleSidenav()"
            [attr.aria-label]="layout.isSidenavExpanded() ? 'Recolher menu' : 'Expandir menu'">
      <mat-icon class="transition-transform duration-300">
        {{ !layout.isMobile() && !layout.isSidenavExpanded() ? 'close' : 'menu' }}
      </mat-icon>
    </button>

    <div class="flex flex-col leading-none md:hidden">
      <span class="text-lg font-semibold tracking-tight">SGP-PM</span>
      <span class="text-xs tracking-widest opacity-60">Polícia Militar</span>
    </div>
  </div>

  <!-- Direita: ações -->
  <div class="flex items-center">
    <button mat-icon-button
            (click)="layout.toggleQuickpanel()"
            aria-label="Painel lateral">
      <mat-icon class="icon-lg">dock_to_right</mat-icon>
    </button>

    <button mat-icon-button
            [matMenuTriggerFor]="notifMenu"
            class="relative"
            aria-label="Notificações">
      <mat-icon class="icon-lg">notifications</mat-icon>
      <span class="absolute top-px right-px min-w-pmdf-4 h-pmdf-4 bg-pmdf-warning/50 text-xs font-semibold rounded-full flex items-center justify-center leading-none">
        3
      </span>
    </button>

    <button mat-icon-button
            routerLink="/settings"
            aria-label="Preferências">
      <mat-icon class="icon-lg">settings</mat-icon>
    </button>

    <button mat-icon-button
            (click)="auth.logout()"
            class="text-pmdf-danger"
            aria-label="Sair">
      <mat-icon class="icon-lg">power_settings_new</mat-icon>
    </button>

    <div class="w-px h-7 mx-pmdf-2 hidden md:block bg-pmdf-primary/10 dark:md:bg-white/10"></div>

    <div [matMenuTriggerFor]="userMenu" class="ml-4 w-8 h-8 rounded-full bg-pmdf-dark-text-secondary/90 text-pmdf-primary dark:md:text-white flex items-center justify-center shrink-0 overflow-hidden cursor-pointer">
      @if (perfil.fotoUrl()) {
        <img [src]="perfil.fotoUrl()" alt="Foto do usuário" class="w-full h-full object-cover" />
      } @else {
        <mat-icon class="icon-base icon-filled">person</mat-icon>
      }
    </div>
  </div>

  <!-- Notificações mat-menu -->
  <mat-menu #notifMenu="matMenu" class="pmdf-dropdown-panel" [overlapTrigger]="false">
    <div (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between p-pmdf-4 border-b border-pmdf-border-subtle">
        <span class="text-pmdf-subheading text-pmdf-text-primary">Notificações</span>
        <span class="bg-pmdf-danger text-white text-[10px] font-bold px-2 py-0.5 rounded-full">
          3 novas
        </span>
      </div>

      <div class="overflow-y-auto divide-y divide-pmdf-border-subtle">
        <div class="flex items-start gap-pmdf-3 p-pmdf-4 hover:bg-pmdf-bg-page/60 transition-colors cursor-pointer">
          <div class="w-9 h-9 rounded-full bg-pmdf-danger/10 flex items-center justify-center shrink-0">
            <mat-icon class="text-pmdf-danger icon-sm icon-filled">assignment_late</mat-icon>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-sm font-semibold text-pmdf-text-primary truncate">Avaliação de Desempenho Pendente</p>
            <p class="text-xs text-pmdf-text-secondary mt-0.5 line-clamp-2">Você tem 3 avaliações da sua equipe aguardando homologação.</p>
            <p class="text-[10px] text-pmdf-text-secondary/60 mt-1">Há 2 horas</p>
          </div>
        </div>

        <div class="flex items-start gap-pmdf-3 p-pmdf-4 hover:bg-pmdf-bg-page/60 transition-colors cursor-pointer">
          <div class="w-9 h-9 rounded-full bg-pmdf-warning/10 flex items-center justify-center shrink-0">
            <mat-icon class="text-pmdf-warning icon-sm icon-filled">hotel</mat-icon>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-sm font-semibold text-pmdf-text-primary truncate">Aprovação de Férias</p>
            <p class="text-xs text-pmdf-text-secondary mt-0.5 line-clamp-2">Solicitação de férias do 3º Sgt PM João Silva requer sua análise.</p>
            <p class="text-[10px] text-pmdf-text-secondary/60 mt-1">Há 4 horas</p>
          </div>
        </div>

        <div class="flex items-start gap-pmdf-3 p-pmdf-4 hover:bg-pmdf-bg-page/60 transition-colors cursor-pointer">
          <div class="w-9 h-9 rounded-full bg-pmdf-info/10 flex items-center justify-center shrink-0">
            <mat-icon class="text-pmdf-info icon-sm icon-filled">article</mat-icon>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-sm font-semibold text-pmdf-text-primary truncate">Novo Boletim Geral Publicado</p>
            <p class="text-xs text-pmdf-text-secondary mt-0.5 line-clamp-2">O BCG PMDF nº 105/2026 já está disponível para consulta.</p>
            <p class="text-[10px] text-pmdf-text-secondary/60 mt-1">Há 1 dia</p>
          </div>
        </div>
      </div>

      <div class="p-pmdf-3 border-t border-pmdf-border-subtle text-center">
        <a class="text-xs text-pmdf-info font-medium hover:underline cursor-pointer">
          Ver todas as notificações &rarr;
        </a>
      </div>
    </div>
  </mat-menu>

  <!-- User mat-menu -->
  <mat-menu #userMenu="matMenu" class="pmdf-dropdown-panel" [overlapTrigger]="false">
    <div class="p-pmdf-4 border-b border-pmdf-border-subtle"
         (click)="$event.stopPropagation()">
      <div class="flex items-center gap-pmdf-3">
        <div class="w-10 h-10 rounded-full bg-pmdf-warning flex items-center justify-center shrink-0 overflow-hidden">
          @if (perfil.fotoUrl()) {
            <img [src]="perfil.fotoUrl()" alt="Foto" class="w-full h-full object-cover" />
          } @else {
            <mat-icon class="text-pmdf-primary icon-filled">person</mat-icon>
          }
        </div>
        <div>
          <p class="text-sm font-bold text-pmdf-text-primary">{{ perfil.postoNomeGuerra() || auth.user()?.name || 'Usuário' }}</p>
          <p class="text-[10px] text-pmdf-text-secondary">Mat: {{ auth.user()?.matricula || '—' }} · {{ auth.user()?.unidade || '—' }}</p>
        </div>
      </div>
    </div>
    <button mat-menu-item routerLink="/perfil">
      <mat-icon>account_circle</mat-icon>
      <span>Meu Perfil</span>
    </button>
    <button mat-menu-item routerLink="/settings">
      <mat-icon>settings</mat-icon>
      <span>Preferências</span>
    </button>
    <mat-divider />
    <button mat-menu-item class="text-pmdf-danger!" (click)="auth.logout()">
      <mat-icon class="text-pmdf-danger!">logout</mat-icon>
      <span>Sair do Sistema</span>
    </button>
  </mat-menu>
</mat-toolbar>
